import {
  SET_STUDENTS, SET_STUDENTS_LOADING,
  SET_STUDENT_SUMMARY,
  SET_STUDENT_PROFILE, SET_STUDENT_PROFILE_LOADING,
  SET_STUDENT_ASSESSMENTS, SET_STUDENT_ASSESSMENTS_LOADING,
  SET_CORPORATE_SUMMARY, SET_CORPORATE_GLOBAL_SUMMARY, SET_CORPORATE_DEPARTMENTS,
  SET_CORPORATE_DEPARTMENTS_TABLE, SET_CORPORATE_DEPARTMENTS_TABLE_LOADING,
  SET_CORPORATE_SHORTLIST, SET_CORPORATE_LOADING,
  SET_CORPORATE_SHORTLIST_TABLE, SET_CORPORATE_SHORTLIST_TABLE_LOADING,
  SET_CORPORATE_CAMPUS_QUALITY,
  SET_CORPORATE_CAMPUS_QUALITY_TABLE, SET_CORPORATE_CAMPUS_QUALITY_TABLE_LOADING,
  SET_CORPORATE_PLACEMENT_SUMMARY, SET_CORPORATE_COMPANIES, SET_CORPORATE_COMPANIES_LOADING,
  SET_INSTITUTES, SET_INSTITUTES_LOADING,
  SET_INSTITUTE_SUMMARY, SET_INSTITUTE_SUMMARY_LOADING,
  SET_INSTITUTE_PLACEMENT, SET_INSTITUTE_PLACEMENT_LOADING,
  SET_FILTER_DEPARTMENTS, SET_FILTER_STATES, SET_FILTER_DEGREES, SET_FILTER_COLLEGES, SET_FILTER_SKILLS, SET_FILTER_CITIES,
} from './actions'

const initialState = {
  students: { data: [], page: 1, limit: 10 },
  studentsLoading: false,
  studentSummary: {},
  studentProfile: null,
  studentProfileLoading: false,
  studentAssessments: [],
  studentAssessmentsLoading: false,

  corporateSummary: {},
  corporateGlobalSummary: {},
  corporateDepartments: [],
  corporateDepartmentsTable: { data: [], total: 0, page: 1, limit: 10 },
  corporateDepartmentsTableLoading: false,
  corporateShortlist: [],
  corporateShortlistTable: { data: [], total: 0, page: 1, limit: 10 },
  corporateShortlistTableLoading: false,
  corporateLoading: false,
  corporateCampusQuality: [],
  corporateCampusQualityTable: { data: [], total: 0, page: 1, limit: 10 },
  corporateCampusQualityTableLoading: false,
  corporatePlacementSummary: {},
  corporateCompanies: { data: [], total: 0, page: 1, limit: 10 },
  corporateCompaniesLoading: false,

  institutes: [],
  institutesLoading: false,
  instituteSummary: null,
  instituteSummaryLoading: false,
  institutePlacement: null,
  institutePlacementLoading: false,

  filterDepartments: [],
  filterStates: [],
  filterDegrees: [],
  filterColleges: [],
  filterSkills: [],
  filterCities: [],
}

const metaDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STUDENTS_LOADING:
      return { ...state, studentsLoading: action.data }
    case SET_STUDENTS:
      return { ...state, students: action.data, studentsLoading: false }
    case SET_STUDENT_SUMMARY:
      return { ...state, studentSummary: action.data }

    case SET_STUDENT_PROFILE_LOADING:
      return { ...state, studentProfileLoading: action.data }
    case SET_STUDENT_PROFILE:
      return { ...state, studentProfile: action.data, studentProfileLoading: false }
    case SET_STUDENT_ASSESSMENTS_LOADING:
      return { ...state, studentAssessmentsLoading: action.data }
    case SET_STUDENT_ASSESSMENTS:
      return { ...state, studentAssessments: action.data, studentAssessmentsLoading: false }

    case SET_CORPORATE_LOADING:
      return { ...state, corporateLoading: action.data }
    case SET_CORPORATE_SUMMARY:
      return { ...state, corporateSummary: action.data }
    case SET_CORPORATE_GLOBAL_SUMMARY:
      return { ...state, corporateGlobalSummary: action.data }
    case SET_CORPORATE_DEPARTMENTS:
      return { ...state, corporateDepartments: action.data }
    case SET_CORPORATE_DEPARTMENTS_TABLE_LOADING:
      return { ...state, corporateDepartmentsTableLoading: action.data }
    case SET_CORPORATE_DEPARTMENTS_TABLE:
      return { ...state, corporateDepartmentsTable: action.data, corporateDepartmentsTableLoading: false }
    case SET_CORPORATE_SHORTLIST:
      return { ...state, corporateShortlist: action.data, corporateLoading: false }
    case SET_CORPORATE_SHORTLIST_TABLE_LOADING:
      return { ...state, corporateShortlistTableLoading: action.data }
    case SET_CORPORATE_SHORTLIST_TABLE:
      return { ...state, corporateShortlistTable: action.data, corporateShortlistTableLoading: false }
    case SET_CORPORATE_CAMPUS_QUALITY:
      return { ...state, corporateCampusQuality: action.data }
    case SET_CORPORATE_CAMPUS_QUALITY_TABLE_LOADING:
      return { ...state, corporateCampusQualityTableLoading: action.data }
    case SET_CORPORATE_CAMPUS_QUALITY_TABLE:
      return { ...state, corporateCampusQualityTable: action.data, corporateCampusQualityTableLoading: false }
    case SET_CORPORATE_PLACEMENT_SUMMARY:
      return { ...state, corporatePlacementSummary: action.data }
    case SET_CORPORATE_COMPANIES_LOADING:
      return { ...state, corporateCompaniesLoading: action.data }
    case SET_CORPORATE_COMPANIES:
      return { ...state, corporateCompanies: action.data, corporateCompaniesLoading: false }

    case SET_INSTITUTES_LOADING:
      return { ...state, institutesLoading: action.data }
    case SET_INSTITUTES:
      return { ...state, institutes: action.data, institutesLoading: false }

    case SET_INSTITUTE_SUMMARY_LOADING:
      return { ...state, instituteSummaryLoading: action.data }
    case SET_INSTITUTE_SUMMARY:
      return { ...state, instituteSummary: action.data, instituteSummaryLoading: false }
    case SET_INSTITUTE_PLACEMENT_LOADING:
      return { ...state, institutePlacementLoading: action.data }
    case SET_INSTITUTE_PLACEMENT:
      return { ...state, institutePlacement: action.data, institutePlacementLoading: false }

    case SET_FILTER_DEPARTMENTS:
      return { ...state, filterDepartments: action.data }
    case SET_FILTER_STATES:
      return { ...state, filterStates: action.data }
    case SET_FILTER_DEGREES:
      return { ...state, filterDegrees: action.data }
    case SET_FILTER_COLLEGES:
      return { ...state, filterColleges: action.data }
    case SET_FILTER_SKILLS:
      return { ...state, filterSkills: action.data }
    case SET_FILTER_CITIES:
      return { ...state, filterCities: action.data }

    default:
      return state
  }
}

export default metaDashboardReducer
